import { render } from "./WeFactProject.vue?vue&type=template&id=434e42db"
const script = {}

import "./WeFactProject.vue?vue&type=style&index=0&id=434e42db&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__